import { isRgbPaintType } from '~/shared';
import { useLayoutSelector } from '../../redux';
import { ColorPicker } from '../ColorPicker';
import {
	CategoryTypes,
	colorSelectItems,
} from '../ColorSelect/ColorSelect.model';

const RGBPalette = () => {
	const shouldShow = useLayoutSelector((state) => {
		const activePaintGroup = state.colorPicker.paintGroup;
		const activeIndex = state.tuningStudio.activeIndex;
		const currentItem = colorSelectItems[activeIndex];

		if (!currentItem) {
			return false;
		}

		const isPaintingInterior =
			currentItem.type === CategoryTypes.PaintingInterior;
		const isPaintingWheels = currentItem.type === CategoryTypes.PaintingWheels;

		if (isPaintingInterior) {
			return true;
		}

		if (isPaintingWheels) {
			return false;
		}

		if (!activePaintGroup || !activePaintGroup?.type) {
			return false;
		}

		return isRgbPaintType(activePaintGroup.type);
	});

	if (!shouldShow) return null;

	return <ColorPicker />;
};

export { RGBPalette };
